import { render, staticRenderFns } from "./linkUs.vue?vue&type=template&id=094b9652&scoped=true"
import script from "./linkUs.vue?vue&type=script&lang=js"
export * from "./linkUs.vue?vue&type=script&lang=js"
import style0 from "./linkUs.vue?vue&type=style&index=0&id=094b9652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094b9652",
  null
  
)

export default component.exports